/* bvm-ricerca.js — RICERCA COME NEL v9 (23/10/2026, sessione C). Guscio: snippets/bvm-ricerca.liquid · contenuto:
   sections/bvm-ricerca-risultati.liquid (Predictive Search di Shopify, /search/suggest) · stile: assets/bvm-ricerca.css.
   · Da 2 caratteri apre il pannello (v9 :1161); attesa di 250 ms dall'ultimo tasto, la richiesta vecchia si annulla, le risposte si
     tengono in memoria per la sessione della pagina. Invio e «Vedi tutti» portano a /search?q= del tema (il modulo del tema).
   · Il campo è quello del tema (input name="q"): la ricerca istantanea DEL TEMA (theme.js, SearchBar) non parte più — l'evento
     «input» si ferma sul modulo — e sotto i 1000 px nemmeno la sua ricerca a tutto schermo (il «focusin» si ferma lì). Da 1000 px
     il «focusin» passa: lo usa il mega menu per il giro della linea.
   · Tastiera: frecce su e giù fra i risultati (combobox con aria-activedescendant), Invio apre il risultato scelto, Esc chiude.
   · Il mega menu sa che il pannello è aperto dalla classe html.bvm-ric-aperta (la lente e il pannello Prodotti stanno fermi). */
(function () {
  var sezione = document.querySelector('.shopify-section__header');
  var guscio = document.querySelector('[data-bvm-ric]');
  if (!sezione || !guscio) return;
  var involucro = sezione.querySelector('.header__search-bar-wrapper');
  var modulo = involucro ? involucro.querySelector('form') : null;
  if (!modulo) return;
  var lastra = sezione.querySelector('section') || sezione;
  lastra.appendChild(guscio); guscio.classList.add('is-pronto');   /* prima di qui il guscio non si vede (CSS): niente salti */

  var mq = window.matchMedia('(min-width: 1000px)');
  var radice = document.documentElement;
  var elenco = guscio.querySelector('[data-bvm-ric-elenco]'), titolo = guscio.querySelector('[data-bvm-ric-titolo]');
  var vuoto = guscio.querySelector('[data-bvm-ric-vuoto]'), tutti = guscio.querySelector('[data-bvm-ric-tutti]');
  var annuncio = guscio.querySelector('[data-bvm-ric-annuncio]');
  var t = function (k, q, n) { return (guscio.getAttribute('data-t-' + k) || '').replace('%q', q || '').replace('%n', n); };
  var radiceUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN = 2, ATTESA = 250;
  var aperto = false, chiesto = '', mostrato = null, attivo = -1, tempo = null, ctrl = null, memoria = {};

  function campo() { return modulo.querySelector('input[name="q"]'); }
  function valore() { var c = campo(); return c ? c.value.trim() : ''; }
  function opzioni() { return Array.prototype.slice.call(elenco.querySelectorAll('[role="option"]')); }

  /* il campo come combobox (WAI-ARIA 1.2) */
  function preparaCampo() {
    var c = campo(); if (!c || c.getAttribute('data-bvm-ric-campo') === '1') return;
    c.setAttribute('data-bvm-ric-campo', '1'); c.setAttribute('role', 'combobox'); c.setAttribute('aria-autocomplete', 'list');
    c.setAttribute('aria-controls', 'bvm-ric-elenco'); c.setAttribute('aria-expanded', aperto ? 'true' : 'false');
  }
  preparaCampo();

  /* × e freccia nel campo (v9 note §4 d): ci sono solo con del testo; da 1000 px (sotto c'è la × del tema) */
  var cornice = involucro.querySelector('.search-bar__top');
  var svuota = document.createElement('button'), vai = document.createElement('button');
  svuota.type = 'button'; svuota.className = 'bvm-ric-svuota'; svuota.setAttribute('aria-label', t('svuota')); svuota.innerHTML = '<span aria-hidden="true">×</span>';
  vai.type = 'submit'; vai.className = 'bvm-ric-vai'; vai.setAttribute('aria-label', t('cerca'));
  vai.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13M13 6.5 18.5 12 13 17.5"/></svg>';
  if (cornice) { cornice.appendChild(svuota); cornice.appendChild(vai); }
  function segnaPieno() { var c = campo(); var pieno = !!(c && c.value); if (cornice) cornice.classList.toggle('bvm-ric-pieno', pieno); if (c) c.classList.toggle('is-filled', pieno); }

  /* l'altezza massima arriva a 12 px dal fondo della finestra (v9 :1155); sotto i 1000 px il pannello sta sotto il fondo
     dell'header e del campo (il più basso dei due), misurato qui */
  function misura() {
    var su;
    if (!mq.matches) {
      var h = sezione.querySelector('header') || lastra;
      su = Math.max(0, Math.round(Math.max(h.getBoundingClientRect().bottom, involucro.getBoundingClientRect().bottom)));
      guscio.style.setProperty('--bvm-ric-su', su + 'px');
    } else su = guscio.getBoundingClientRect().top;
    guscio.style.setProperty('--bvm-ric-max', Math.max(160, Math.round(window.innerHeight - Math.max(su, 0) - 12)) + 'px');
  }
  window.addEventListener('scroll', function () { if (aperto && !mq.matches) misura(); }, { passive: true });
  function apri() {
    if (aperto) return; aperto = true;
    misura(); guscio.classList.add('is-aperto'); radice.classList.add('bvm-ric-aperta');
    var c = campo(); if (c) c.setAttribute('aria-expanded', 'true');
  }
  function chiudi() {
    if (!aperto) return; aperto = false; scegli(-1);
    guscio.classList.remove('is-aperto'); radice.classList.remove('bvm-ric-aperta');
    var c = campo(); if (c) c.setAttribute('aria-expanded', 'false');
  }
  function azzera(riporta) {
    var c = campo(); if (c) c.value = ''; chiesto = ''; segnaPieno(); chiudi();
    if (ctrl) { ctrl.abort(); ctrl = null; } clearTimeout(tempo);
    if (riporta && c) c.focus();
  }

  function scegli(i) {
    var o = opzioni(); var c = campo();
    if (attivo >= 0 && o[attivo]) { o[attivo].classList.remove('is-scelta'); o[attivo].setAttribute('aria-selected', 'false'); }
    attivo = (i >= 0 && i < o.length) ? i : -1;
    if (attivo >= 0) {
      o[attivo].classList.add('is-scelta'); o[attivo].setAttribute('aria-selected', 'true');
      if (c) c.setAttribute('aria-activedescendant', o[attivo].id);
      if (o[attivo].scrollIntoView) o[attivo].scrollIntoView({ block: 'nearest' });
    } else if (c) c.removeAttribute('aria-activedescendant');
  }

  function mostra(q, html) {
    var box = document.createElement('div'); box.innerHTML = html;
    var ris = box.querySelector('[data-bvm-ric-risultati]');
    var colonne = ris ? ris.querySelector('.bvm-ric__colonne') : null;
    var segno = ris ? ris.querySelector('[data-bvm-ric-colonne]') : null;
    var n = segno ? Number(segno.getAttribute('data-bvm-ric-colonne')) || 0 : 0;
    attivo = -1; mostrato = q;
    elenco.innerHTML = colonne ? colonne.outerHTML : '';
    guscio.setAttribute('data-colonne', String(n));
    opzioni().forEach(function (o, i) { o.id = 'bvm-ric-o-' + i; o.tabIndex = -1; });
    titolo.textContent = t('titolo', q);
    var quanti = opzioni().length;
    vuoto.hidden = quanti > 0; if (!quanti) vuoto.textContent = t('vuoto', q);
    tutti.hidden = quanti === 0;
    tutti.href = radiceUrl + 'search?q=' + encodeURIComponent(q);
    annuncio.textContent = quanti === 1 ? t('uno') : (quanti ? t('tanti', '', quanti) : t('vuoto', q));
    guscio.classList.remove('is-carica');
    if (aperto) misura();
  }
  function errore(q) {
    attivo = -1; mostrato = null; elenco.innerHTML = ''; guscio.setAttribute('data-colonne', '0');
    titolo.textContent = t('titolo', q); vuoto.hidden = false; vuoto.textContent = t('errore');
    tutti.hidden = false; tutti.href = radiceUrl + 'search?q=' + encodeURIComponent(q);
    annuncio.textContent = t('errore'); guscio.classList.remove('is-carica');
  }

  function chiedi(q) {
    chiesto = q;
    if (memoria[q] != null) { mostra(q, memoria[q]); apri(); return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new window.AbortController() : null;
    guscio.classList.add('is-carica'); annuncio.textContent = t('carica');
    var url = radiceUrl + 'search/suggest?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,article&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last'
      + '&section_id=bvm-ricerca-risultati';
    window.fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { memoria[q] = html; if (q !== chiesto || valore() !== q) return; mostra(q, html); apri(); })
      .catch(function (e) { if (e && e.name === 'AbortError') return; if (q !== chiesto) return; errore(q); apri(); });
  }

  function suTesto() {
    preparaCampo(); segnaPieno();
    var q = valore(); clearTimeout(tempo);
    if (q.length < MIN) { chiesto = ''; if (ctrl) { ctrl.abort(); ctrl = null; } chiudi(); return; }
    tempo = setTimeout(function () { if (valore() === q) chiedi(q); }, ATTESA);
  }

  /* gli ascolti stanno sul MODULO, in cattura: arrivano prima di quelli del tema, che stanno sul contenitore */
  modulo.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('input[name="q"]')) return;
    e.stopPropagation(); suTesto();
  }, true);
  modulo.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('input[name="q"]')) return;
    preparaCampo();
    if (!mq.matches) e.stopPropagation();   /* sotto i 1000 px niente ricerca a tutto schermo del tema */
    var q = valore();
    if (q.length >= MIN) { if (mostrato === q) apri(); else chiedi(q); }
  }, true);
  modulo.addEventListener('keydown', function (e) {
    if (!e.target.matches || !e.target.matches('input[name="q"]')) return;
    var o = opzioni();
    if (e.key === 'ArrowDown' || e.key === 'Down') { if (!aperto || !o.length) return; e.preventDefault(); scegli(attivo + 1 >= o.length ? 0 : attivo + 1); }
    else if (e.key === 'ArrowUp' || e.key === 'Up') { if (!aperto || !o.length) return; e.preventDefault(); scegli(attivo <= 0 ? -1 : attivo - 1); }
    else if (e.key === 'Enter') { if (aperto && attivo >= 0 && o[attivo]) { e.preventDefault(); window.location.href = o[attivo].href; } }
    else if (e.key === 'Escape' || e.key === 'Esc') { if (aperto) { chiudi(); } }
    else if (e.key === 'Tab') { e.stopPropagation(); /* il tema porterebbe il fuoco nei SUOI risultati (vuoti) */ }
  }, true);
  modulo.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-action="clear-input"]')) { setTimeout(function () { azzera(false); }, 0); return; }
    /* clic nel campo che ha già il fuoco (dopo Esc o un clic fuori): niente «focusin», il pannello si riapre da qui */
    if (!aperto && e.target.matches && e.target.matches('input[name="q"]')) { var q = valore(); if (q.length >= MIN) { if (mostrato === q) apri(); else chiedi(q); } }
  });
  svuota.addEventListener('click', function () { azzera(true); });
  guscio.querySelector('[data-bvm-ric-chiudi]').addEventListener('click', function () { azzera(false); var c = campo(); if (c) c.focus(); });
  elenco.addEventListener('mousemove', function (e) { var a = e.target.closest ? e.target.closest('[role="option"]') : null; if (a) { var i = opzioni().indexOf(a); if (i !== attivo) scegli(i); } });
  /* un clic fuori dal campo e dal pannello chiude (il testo resta: rientrando nel campo il pannello si riapre) */
  document.addEventListener('click', function (e) { if (aperto && !involucro.contains(e.target) && !guscio.contains(e.target)) chiudi(); });
  /* Esc col fuoco nel pannello */
  guscio.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') { chiudi(); var c = campo(); if (c) c.focus(); } });
  window.addEventListener('resize', function () { if (aperto) misura(); });
  mq.addListener ? mq.addListener(function () { if (aperto) misura(); }) : null;
  /* il «Torna indietro» del browser riporta la pagina dalla cache col testo nel campo: si riallinea */
  window.addEventListener('pageshow', function () { segnaPieno(); chiudi(); });
})();
